import { useEffect } from "react";

// Adds `.in-view` class to elements with `.reveal`, `.reveal-left`, `.reveal-right`, `.reveal-zoom`
// when they enter viewport. Runs once per element.
export default function useScrollReveal() {
  useEffect(() => {
    const selector = ".reveal, .reveal-left, .reveal-right, .reveal-zoom";
    const els = Array.from(document.querySelectorAll(selector));
    if (!els.length) return;

    if (typeof IntersectionObserver === "undefined") {
      els.forEach((el) => el.classList.add("in-view"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -60px 0px", threshold: 0.08 }
    );

    els.forEach((el) => io.observe(el));

    // Re-scan a bit later for late-mounted children (e.g., gallery dialog content)
    const t = setTimeout(() => {
      document.querySelectorAll(selector).forEach((el) => {
        if (!el.classList.contains("in-view")) io.observe(el);
      });
    }, 500);

    return () => {
      clearTimeout(t);
      io.disconnect();
    };
  }, []);
}
